export function normalizeActivationPath(pathname) {
  if (typeof pathname !== 'string') {
    return null
  }

  const trimmedPath = pathname.trim()
  if (!trimmedPath) {
    return null
  }

  const [pathWithoutHash] = trimmedPath.split('#')
  const [pathWithoutQuery] = pathWithoutHash.split('?')
  let normalizedPath = pathWithoutQuery || '/'

  if (!normalizedPath.startsWith('/')) {
    normalizedPath = `/${normalizedPath}`
  }

  if (normalizedPath.length > 1 && normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath.replace(/\/+$/, '')
  }

  return normalizedPath
}

export function buildTrackedActivationHref({
  activationId,
  fromPage,
  placement,
  sessionId,
}) {
  const searchParams = new URLSearchParams()
  const normalizedFromPage = normalizeActivationPath(fromPage)

  if (normalizedFromPage) {
    searchParams.set('fromPage', normalizedFromPage)
  }

  if (placement) {
    searchParams.set('placement', placement)
  }

  if (sessionId) {
    searchParams.set('sessionId', sessionId)
  }

  const query = searchParams.toString()

  return `/a/${activationId}${query ? `?${query}` : ''}`
}
